import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import './Logo.scss';

const Logo = props => {
  const { navCollapsed, logoLinkTo } = props;

  return (
    <div className="logo">
      <Link
        style={{
          background: "left center url('/view/static/mp/images/logo-icon.png') no-repeat",
          backgroundSize: 30,
          display: 'block',
          padding: '13px 0 0 25px'
        }}
        to={logoLinkTo}
      >
        <img
          src="/view/static/mp/images/logo-text.png"
          alt="MarketPay"
          className={`${navCollapsed ? 'logo__image--collapsed' : 'logo__image'}`}
        />
      </Link>
    </div>
  );
};

Logo.propTypes = {
  navCollapsed: PropTypes.bool,
  logoLinkTo: PropTypes.string
};

export default Logo;
